(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28449],{

/***/ 66607:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,function(){"use strict";return function(e,t,i){t.prototype.isBetween=function(e,t,s,f){var n=i(e),o=i(t),r="("===(f=f||"()")[0],u=")"===f[1];return(r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))}}});


/***/ }),

/***/ 28449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_CartManager; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./redux/actions/products.ts
var products = __webpack_require__(86730);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/actions/user.ts
var user = __webpack_require__(76809);
// EXTERNAL MODULE: ./redux/actions/promotions.ts + 1 modules
var promotions = __webpack_require__(18919);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/parameters.ts


var getParameters = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.root */.KU.root,
        uid: "brand/parameters"
    });
};

;// CONCATENATED MODULE: ./redux/actions/parameters.ts

var ACTIONS = {
    GET_PARAMETERS_REQUEST: 'GET_PARAMETERS_REQUEST',
    GET_PARAMETERS_SUCCESS: 'GET_PARAMETERS_SUCCESS',
    GET_PARAMETERS_FAILURE: 'GET_PARAMETERS_FAILURE'
};
var GET_PARAMETERS_REQUEST = function() {
    return {
        type: ACTIONS.GET_PARAMETERS_REQUEST
    };
};
var GET_PARAMETERS_SUCCESS = function(parameters) {
    return {
        type: ACTIONS.GET_PARAMETERS_SUCCESS,
        parameters: parameters
    };
};
var GET_PARAMETERS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PARAMETERS_FAILURE,
        err: err
    };
};
function parameters_getParameters() {
    return function(dispatch) {
        dispatch(GET_PARAMETERS_REQUEST());
        return getParameters().then(function(response) {
            return dispatch(GET_PARAMETERS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_PARAMETERS_FAILURE(err));
        });
    };
}

;// CONCATENATED MODULE: ./redux/services/countries.ts


var getCountries = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.countries */.KU.countries,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        isV2: true
    });
};

;// CONCATENATED MODULE: ./redux/actions/countries.tsx

var countries_ACTIONS = {
    GET_COUNTRIES_REQUEST: 'GET_COUNTRIES_REQUEST',
    GET_COUNTRIES_SUCCESS: 'GET_COUNTRIES_SUCCESS',
    GET_COUNTRIES_FAILURE: 'GET_COUNTRIES_FAILURE'
};
var GET_COUNTRIES_REQUEST = function() {
    return {
        type: countries_ACTIONS.GET_COUNTRIES_REQUEST
    };
};
var GET_COUNTRIES_SUCCESS = function(countries) {
    return {
        type: countries_ACTIONS.GET_COUNTRIES_SUCCESS,
        countries: countries
    };
};
var GET_COUNTRIES_FAILURE = function(err) {
    return {
        type: countries_ACTIONS.GET_COUNTRIES_FAILURE,
        err: err
    };
};
function countries_getCountries() {
    return function(dispatch) {
        dispatch(GET_COUNTRIES_REQUEST());
        return getCountries().then(function(response) {
            return dispatch(GET_COUNTRIES_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_COUNTRIES_FAILURE(err));
        });
    };
}

// EXTERNAL MODULE: ./redux/actions/contract.ts + 1 modules
var contract = __webpack_require__(97506);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./managers/product/packManager.tsx
var getAssociatedProducts = function(associations) {
    var listAssociatedItems = [];
    (associations === null || associations === void 0 ? void 0 : associations.length) > 0 && (associations === null || associations === void 0 ? void 0 : associations.forEach(function(association) {
        if (association === null || association === void 0 ? void 0 : association.products) {
            listAssociatedItems.push(association === null || association === void 0 ? void 0 : association.products);
        }
    }));
    return listAssociatedItems;
};

// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/customParseFormat.js
var customParseFormat = __webpack_require__(10285);
var customParseFormat_default = /*#__PURE__*/__webpack_require__.n(customParseFormat);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(66607);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
// EXTERNAL MODULE: ./redux/actions/takeBack.ts + 1 modules
var takeBack = __webpack_require__(42738);
// EXTERNAL MODULE: ./redux/actions/wishList.ts + 1 modules
var wishList = __webpack_require__(94624);
// EXTERNAL MODULE: ./utils/businessDays.ts
var businessDays = __webpack_require__(67202);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(61436);
;// CONCATENATED MODULE: ./components/CartManager.tsx























function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
dayjs_min_default().extend((customParseFormat_default()));
dayjs_min_default().extend((isBetween_default()));
var resolveMinimumStartingDays = function(storeMinimumStartingDays, parameterMinimumStartingDays) {
    return storeMinimumStartingDays ? storeMinimumStartingDays : parameterMinimumStartingDays ? parameterMinimumStartingDays : 7;
};
var resolveMinimumLeasingDays = function(storeMinimumLeasingDays, parameterMinimumLeasingDays) {
    return storeMinimumLeasingDays ? storeMinimumLeasingDays : parameterMinimumLeasingDays ? parseInt("".concat(parameterMinimumLeasingDays)) : 2;
};
var getStartDateWithBlockedRange = function(minimumStartingDays, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms, blockedStart, blockedEnd) {
    var minimumStartDate = (0,businessDays/* getMinimumStartDate */.u)(minimumStartingDays, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms);
    var startDate = minimumStartDate;
    if (blockedStart && blockedEnd) {
        var blocked_start = dayjs_min_default()(blockedStart);
        var blocked_end = dayjs_min_default()(blockedEnd);
        if (startDate.isBetween(blocked_start, blocked_end, null, '[]')) {
            startDate = blocked_end.add(1, 'day');
            while((0,businessDays/* isNonBusinessDay */.o)(startDate, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms)){
                startDate = startDate.add(1, 'day');
            }
            if (startDate.isBefore(minimumStartDate, 'day')) {
                startDate = minimumStartDate;
            }
        }
    }
    return startDate;
};
var getEndDate = function(startDate, minimumLeasingDays) {
    return dayjs_min_default()(startDate).add(minimumLeasingDays - 1, 'day').toDate();
};
var getStartAndEndDate = function(minimumStartingDays, minimumLeasingDays, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms, blockedStart, blockedEnd) {
    var startDate = getStartDateWithBlockedRange(minimumStartingDays, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms, blockedStart, blockedEnd);
    var endDate = getEndDate(startDate, minimumLeasingDays);
    return {
        startDate: startDate,
        endDate: endDate
    };
};
var mapStateToProps = function(state) {
    return {
        cart: state.cart,
        products: state.products,
        product: state.product,
        parameters: state.parameters,
        packs: state.packs,
        user: state.user,
        promotions: state.promotions,
        stores: state.stores,
        contract: state.contract,
        prismic: state.prismic
    };
};
var mapDispatchToProps = {
    getBasketStock: products/* getBasketStock */.w_,
    getParameters: parameters_getParameters,
    getStock: products/* getStock */.K5,
    getUserOrders: user/* getUserOrders */.uI,
    setFuturePrice: promotions/* setFuturePrice */.mW,
    getUser: user/* getUser */.PR,
    finishSessionCheck: user/* finishSessionCheck */.mQ,
    deleteUser: user/* deleteUser */.h8,
    getPromotions: promotions/* getPromotions */.Fh,
    getCountries: countries_getCountries,
    getInProgressContractCSUB: contract/* getInProgressContractCSUB */.UF,
    getInProgressContractSUB: contract/* getInProgressContractSUB */.R0,
    getUserBalance: user/* getUserBalance */.n3,
    getTakeBackStock: takeBack/* getTakeBackStock */.Rl,
    noStock: products/* noStock */.hh,
    checkWishListExistence: wishList/* checkWishListExistence */.GK
};
var CartManager = function(param) {
    var children = param.children, packs = param.packs, getBasketStock1 = param.getBasketStock, getUserOrders1 = param.getUserOrders, getUser1 = param.getUser, finishSessionCheck1 = param.finishSessionCheck, getPromotions1 = param.getPromotions, deleteUser1 = param.deleteUser, setFuturePrice1 = param.setFuturePrice, getParameters1 = param.getParameters, getInProgressContractCSUB1 = param.getInProgressContractCSUB, getInProgressContractSUB1 = param.getInProgressContractSUB, checkWishListExistence1 = param.checkWishListExistence, stores = param.stores, parameters = param.parameters, getCountries1 = param.getCountries, promotions = param.promotions, getStock1 = param.getStock, getTakeBackStock1 = param.getTakeBackStock, noStock1 = param.noStock, user = param.user, product1 = param.product, products = param.products, cart = param.cart, prismic = param.prismic, getUserBalance1 = param.getUserBalance;
    var ref29, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    var ref23 = (0,useCart/* useCart */.j)(), deleteCart = ref23.deleteCart, createCart = ref23.createCart, createSubscriptionCart = ref23.createSubscriptionCart, getCart = ref23.getCart, updateCartSubscription = ref23.updateCartSubscription;
    // Hook used to check if component is already mounted, to prevent it to call each useEffect hooks on all rendering
    var didMountProducts = (0,react.useRef)(false);
    var didMountProduct = (0,react.useRef)(false);
    var didMountPacks = (0,react.useRef)(false);
    var ref24 = (0,react.useState)(new Set()), publicHolidays = ref24[0], setPublicHolidays = ref24[1];
    var ref25 = (0,react.useState)(false), holidaysLoaded = ref25[0], setHolidaysLoaded = ref25[1];
    var router = (0,next_router.useRouter)();
    var warehouseId = stores === null || stores === void 0 ? void 0 : (ref29 = stores.selectedStore) === null || ref29 === void 0 ? void 0 : ref29.warehouseId;
    if (!warehouseId && constants/* customWarehouse */.lL && !isNaN(+constants/* customWarehouse */.lL)) {
        warehouseId = +constants/* customWarehouse */.lL;
    }
    var isEnableChooseStartingDate = parameters === null || parameters === void 0 ? void 0 : (ref1 = parameters.items) === null || ref1 === void 0 ? void 0 : ref1.enableChooseStartingDate;
    var getBlockedDateRange = function() {
        var ref, ref26, ref27, ref28;
        return (0,isValid/* default */.Z)(new Date(prismic === null || prismic === void 0 ? void 0 : (ref = prismic.general) === null || ref === void 0 ? void 0 : ref.blocked_dates_start)) && (0,isValid/* default */.Z)(new Date(prismic === null || prismic === void 0 ? void 0 : (ref26 = prismic.general) === null || ref26 === void 0 ? void 0 : ref26.blocked_dates_end)) ? {
            start: new Date(prismic === null || prismic === void 0 ? void 0 : (ref27 = prismic.general) === null || ref27 === void 0 ? void 0 : ref27.blocked_dates_start),
            end: new Date(prismic === null || prismic === void 0 ? void 0 : (ref28 = prismic.general) === null || ref28 === void 0 ? void 0 : ref28.blocked_dates_end)
        } : undefined;
    };
    var getCustomId = function() {
        var ref;
        return router.route === '/payment' ? (ref = router.asPath.match(/customId=([^&]+)/)) === null || ref === void 0 ? void 0 : ref[1] : undefined;
    };
    (0,react.useEffect)(function() {
        if (true) {
            setHolidaysLoaded(true);
            return;
        }
        var fetchPublicHolidays = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var currentYear, ref, responseNow, responsePlusOne, ref30, dataNow, dataPlusOne;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            currentYear = dayjs_min_default()().year();
                            _ctx.t0 = _slicedToArray;
                            _ctx.next = 5;
                            return Promise.all([
                                fetch("".concat(requests/* ERequestUrl.apiGouvFr */.KU.apiGouvFr, "/").concat(currentYear, ".json")),
                                fetch("".concat(requests/* ERequestUrl.apiGouvFr */.KU.apiGouvFr, "/").concat(currentYear + 1, ".json")), 
                            ]);
                        case 5:
                            _ctx.t1 = _ctx.sent;
                            ref = (0, _ctx.t0)(_ctx.t1, 2);
                            responseNow = ref[0];
                            responsePlusOne = ref[1];
                            _ctx.t2 = _slicedToArray;
                            _ctx.next = 12;
                            return Promise.all([
                                responseNow.json(),
                                responsePlusOne.json(), 
                            ]);
                        case 12:
                            _ctx.t3 = _ctx.sent;
                            ref30 = (0, _ctx.t2)(_ctx.t3, 2);
                            dataNow = ref30[0];
                            dataPlusOne = ref30[1];
                            setPublicHolidays(new Set(_toConsumableArray(Object.keys(dataNow)).concat(_toConsumableArray(Object.keys(dataPlusOne)))));
                            _ctx.next = 22;
                            break;
                        case 19:
                            _ctx.prev = 19;
                            _ctx.t4 = _ctx["catch"](0);
                            // On fetch failure, publicHolidays stays empty and cart proceeds without holiday blocking
                            console.error('Error fetching public holidays:', _ctx.t4);
                        case 22:
                            _ctx.prev = 22;
                            setHolidaysLoaded(true);
                            return _ctx.finish(22);
                        case 25:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        19,
                        22,
                        25
                    ]
                ]);
            }));
            return function fetchPublicHolidays() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPublicHolidays();
    }, []);
    // useEffect
    (0,react.useEffect)(function() {
        var createCartPromise;
        _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref31, ref32, ref33, ref34, ref35, ref36, ref37, minimumStartingDays, minimumLeasingDays, isSaturdayABusinessDay, disableSundayFromCms, customId, ref38, ref39, ref40, startDate, endDate, startSubscriptionDate, savedStartDate, minimumStartDate, useSavedDate, endStartDate, startDate1, endDate1, startDate2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (prismic === null || prismic === void 0 ? void 0 : prismic.general) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (holidaysLoaded) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (parameters === null || parameters === void 0 ? void 0 : parameters.items) {
                            ;
                            minimumStartingDays = resolveMinimumStartingDays(stores === null || stores === void 0 ? void 0 : (ref = stores.selectedStore) === null || ref === void 0 ? void 0 : ref.minimumStartingDays, parameters === null || parameters === void 0 ? void 0 : (ref31 = parameters.items) === null || ref31 === void 0 ? void 0 : ref31.minimumStartingDays);
                            minimumLeasingDays = resolveMinimumLeasingDays(stores === null || stores === void 0 ? void 0 : (ref32 = stores.selectedStore) === null || ref32 === void 0 ? void 0 : ref32.minimumLeasingDays, parameters === null || parameters === void 0 ? void 0 : (ref33 = parameters.items) === null || ref33 === void 0 ? void 0 : ref33.minimumLeasingDays);
                            isSaturdayABusinessDay = parameters === null || parameters === void 0 ? void 0 : (ref34 = parameters.items) === null || ref34 === void 0 ? void 0 : ref34.isSaturdayABusinessDay;
                            disableSundayFromCms = !!(prismic === null || prismic === void 0 ? void 0 : (ref35 = prismic.general) === null || ref35 === void 0 ? void 0 : ref35.disable_sunday_on_date_picker);
                            customId = getCustomId();
                            if (!cart.item && cart.status !== 'cart deleted' && cart.status !== 'error') {
                                if (localStorage.getItem('CartToken') || customId) {
                                    getCart(customId, getBlockedDateRange());
                                } else if (cart.status !== 'cart deleted for DP') {
                                    if (!constants/* isSubscription */.Nn || isEnableChooseStartingDate) {
                                        ;
                                        ref40 = getStartAndEndDate(minimumStartingDays, minimumLeasingDays, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms, prismic === null || prismic === void 0 ? void 0 : (ref38 = prismic.general) === null || ref38 === void 0 ? void 0 : ref38.blocked_dates_start, prismic === null || prismic === void 0 ? void 0 : (ref39 = prismic.general) === null || ref39 === void 0 ? void 0 : ref39.blocked_dates_end), startDate = ref40.startDate, endDate = ref40.endDate;
                                        createCartPromise = setTimeout(function() {
                                            return createCart(dayjs_min_default()(startDate), dayjs_min_default()(endDate), warehouseId);
                                        }, 700);
                                    } else {
                                        startSubscriptionDate = (0,businessDays/* getMinimumStartDate */.u)(minimumStartingDays, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms);
                                        createSubscriptionCart(startSubscriptionDate, 1, warehouseId);
                                    }
                                }
                            } else if (cart.status === 'error' && (((ref36 = cart.error) === null || ref36 === void 0 ? void 0 : ref36.message) === 'Request failed with status code 404' || ((ref37 = cart.error) === null || ref37 === void 0 ? void 0 : ref37.message) === 'Request failed with status code 400') || cart.status === 'cart deleted') {
                                // cart not found, create new one
                                // remove current Cart token to save the new one
                                localStorage.removeItem('CartToken');
                                savedStartDate = localStorage.getItem("".concat(constants/* SAVED_START_DATE */.zf));
                                minimumStartDate = (0,businessDays/* getMinimumStartDate */.u)(minimumStartingDays, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms);
                                useSavedDate = dayjs_min_default()(savedStartDate, 'DD/MM/YYYY').diff(minimumStartDate, 'day') >= 0;
                                if (!constants/* isSubscription */.Nn) {
                                    endStartDate = localStorage.getItem("".concat(constants/* SAVED_END_DATE */.mG));
                                    startDate1 = minimumStartDate;
                                    endDate1 = dayjs_min_default()(startDate1).add(minimumLeasingDays - 1, 'day').toDate();
                                    createCartPromise = setTimeout(function() {
                                        return createCart(savedStartDate && useSavedDate ? dayjs_min_default()(savedStartDate, 'DD/MM/YYYY') : startDate1, endStartDate && useSavedDate ? dayjs_min_default()(endStartDate, 'DD/MM/YYYY') : dayjs_min_default()(endDate1), warehouseId);
                                    }, 700);
                                } else {
                                    startDate2 = minimumStartDate;
                                    createSubscriptionCart(savedStartDate && useSavedDate ? dayjs_min_default()(savedStartDate, 'DD/MM/YYYY') : dayjs_min_default()(startDate2), 1, warehouseId);
                                }
                            }
                        }
                        if ((cart === null || cart === void 0 ? void 0 : cart.item) && cart.status === 'cart live' && !localStorage.getItem('CartToken')) {
                            localStorage.setItem('CartToken', cart.item.tokenValue);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
        return function() {
            if (createCartPromise) {
                clearTimeout(createCartPromise);
            }
        };
    }, [
        cart.item,
        cart.status,
        holidaysLoaded,
        publicHolidays,
        parameters === null || parameters === void 0 ? void 0 : parameters.items,
        prismic === null || prismic === void 0 ? void 0 : prismic.general,
        stores === null || stores === void 0 ? void 0 : stores.selectedStore, 
    ]);
    // Delete cart if locale change
    (0,react.useEffect)(function() {
        var ref;
        if ((cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.tokenValue) && cart.status === 'cart live' && !cart.loading && cart.item.locale.substring(0, 2) !== router.locale) {
            deleteCart();
        }
    }, [
        router.locale,
        cart === null || cart === void 0 ? void 0 : (ref2 = cart.item) === null || ref2 === void 0 ? void 0 : ref2.tokenValue
    ]);
    // Update a subscription cart to receive informations about price changes because of current subscription
    (0,react.useEffect)(function() {
        var ref, ref41, ref42;
        // We need to be in subscription mode, we need a cart and a user, and a specific cart state (shipping method not currently selected)
        if ((cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.tokenValue) && (user === null || user === void 0 ? void 0 : (ref41 = user.user) === null || ref41 === void 0 ? void 0 : ref41.id) && (cart === null || cart === void 0 ? void 0 : (ref42 = cart.item) === null || ref42 === void 0 ? void 0 : ref42.checkoutState) === 'cart' && !(cart === null || cart === void 0 ? void 0 : cart.isUpdated)) {
            updateCartSubscription();
        }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref3 = cart.item) === null || ref3 === void 0 ? void 0 : ref3.tokenValue,
        user === null || user === void 0 ? void 0 : (ref4 = user.user) === null || ref4 === void 0 ? void 0 : ref4.id
    ]);
    // Products Stock Management
    (0,react.useEffect)(function() {
        if (didMountProducts.current === true) {
            var ref, ref43, ref44, ref45, ref46;
            var _products = (products === null || products === void 0 ? void 0 : (ref = products.items) === null || ref === void 0 ? void 0 : ref.items) && (products === null || products === void 0 ? void 0 : (ref43 = products.items) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.items) === null || ref44 === void 0 ? void 0 : ref44.length) > 0 ? products === null || products === void 0 ? void 0 : (ref45 = products.items) === null || ref45 === void 0 ? void 0 : ref45.items : (products === null || products === void 0 ? void 0 : (ref46 = products.wishList) === null || ref46 === void 0 ? void 0 : ref46.items) || [];
            if ((_products === null || _products === void 0 ? void 0 : _products.length) > 0 && products.loading === false && cart.status === 'cart live') {
                var ref47, ref48;
                // if we use cumulative products, we don't need to find the stock for the products that has already loaded
                // so we cut the current product stock we have frome the array of SKUs to get only the one we charge
                var SKUArray = [];
                if (products === null || products === void 0 ? void 0 : products.isCumulative) {
                    var newArray = [];
                    newArray = _toConsumableArray(_products);
                    var limit = products.items.limit * (products.items.page - 1);
                    if (products.items.page > 1) {
                        newArray.splice(0, limit);
                    }
                    SKUArray = (0,utils/* getSkus */.ES)(newArray);
                } else {
                    SKUArray = (0,utils/* getSkus */.ES)(_products);
                }
                if (((ref47 = cart.item) === null || ref47 === void 0 ? void 0 : ref47.startLeasingDate) && ((ref48 = cart.item) === null || ref48 === void 0 ? void 0 : ref48.endLeasingDate) && !constants/* isSubscription */.Nn) {
                    if (SKUArray.length > 0) {
                        var ref49, ref50, ref51;
                        var data = {
                            lizeeSKUs: SKUArray,
                            from: dayjs_min_default()((ref49 = cart.item) === null || ref49 === void 0 ? void 0 : ref49.startLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                            to: dayjs_min_default()((ref50 = cart.item) === null || ref50 === void 0 ? void 0 : ref50.endLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                        };
                        getStock1(data, warehouseId);
                        getTakeBackStock1(data);
                        (prismic === null || prismic === void 0 ? void 0 : (ref51 = prismic.general) === null || ref51 === void 0 ? void 0 : ref51.wishlist_enabled) && checkWishListExistence1(_products.map(function(p) {
                            return p.id;
                        }));
                    }
                } else {
                    var SKUArray1 = (0,utils/* getSkus */.ES)(_products);
                    if (SKUArray1.length > 0) {
                        var ref52;
                        var data1 = {
                            lizeeSKUs: SKUArray1
                        };
                        getStock1(data1, warehouseId);
                        getTakeBackStock1(data1);
                        (prismic === null || prismic === void 0 ? void 0 : (ref52 = prismic.general) === null || ref52 === void 0 ? void 0 : ref52.wishlist_enabled) && checkWishListExistence1(_products.map(function(p) {
                            return p.id;
                        }));
                    }
                }
            }
        } else {
            didMountProducts.current = true;
            noStock1();
        }
    }, [
        didMountProducts,
        products.items,
        (ref5 = products.wishList) === null || ref5 === void 0 ? void 0 : ref5.items,
        (ref6 = cart.item) === null || ref6 === void 0 ? void 0 : ref6.startLeasingDate,
        (ref7 = cart.item) === null || ref7 === void 0 ? void 0 : ref7.endLeasingDate, 
    ]);
    // Basket Stock Management
    (0,react.useEffect)(function() {
        var ref;
        if ((cart === null || cart === void 0 ? void 0 : cart.item) && ((ref = cart.item.items) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var ref53, ref54, ref55, ref56;
            var SKUArray = [];
            cart === null || cart === void 0 ? void 0 : (ref53 = cart.item) === null || ref53 === void 0 ? void 0 : (ref54 = ref53.items) === null || ref54 === void 0 ? void 0 : ref54.map(function(item) {
                SKUArray.push(item.product.variants[0].sku);
            });
            if (((ref55 = cart.item) === null || ref55 === void 0 ? void 0 : ref55.startLeasingDate) && ((ref56 = cart.item) === null || ref56 === void 0 ? void 0 : ref56.endLeasingDate) && !constants/* isSubscription */.Nn) {
                if (SKUArray.length > 0) {
                    var ref57, ref58;
                    var data = {
                        lizeeSKUs: SKUArray,
                        from: dayjs_min_default()((ref57 = cart.item) === null || ref57 === void 0 ? void 0 : ref57.startLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                        to: dayjs_min_default()((ref58 = cart.item) === null || ref58 === void 0 ? void 0 : ref58.endLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    };
                    getBasketStock1(data, warehouseId);
                }
            } else {
                if (SKUArray.length > 0) {
                    var data2 = {
                        lizeeSKUs: SKUArray
                    };
                    getBasketStock1(data2, warehouseId);
                }
            }
        }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref8 = cart.item) === null || ref8 === void 0 ? void 0 : ref8.items,
        (ref9 = cart.item) === null || ref9 === void 0 ? void 0 : ref9.startLeasingDate,
        (ref10 = cart.item) === null || ref10 === void 0 ? void 0 : ref10.endLeasingDate,
        router.pathname, 
    ]);
    // Single product Stock Management
    (0,react.useEffect)(function() {
        if (didMountProduct.current === true) {
            if (product1.item && product1.loading === false && cart.status === 'cart live') {
                var ref, ref59;
                if (((ref = cart.item) === null || ref === void 0 ? void 0 : ref.startLeasingDate) && ((ref59 = cart.item) === null || ref59 === void 0 ? void 0 : ref59.endLeasingDate) && !constants/* isSubscription */.Nn) {
                    var SKUArray = (0,utils/* getSkus */.ES)(product1.item);
                    if (SKUArray.length > 0) {
                        var ref60, ref61, ref62;
                        var data = {
                            lizeeSKUs: SKUArray,
                            from: dayjs_min_default()((ref60 = cart.item) === null || ref60 === void 0 ? void 0 : ref60.startLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                            to: dayjs_min_default()((ref61 = cart.item) === null || ref61 === void 0 ? void 0 : ref61.endLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                        };
                        getStock1(data, warehouseId);
                        (prismic === null || prismic === void 0 ? void 0 : (ref62 = prismic.general) === null || ref62 === void 0 ? void 0 : ref62.wishlist_enabled) && checkWishListExistence1([
                            product1.item.id
                        ]);
                    }
                } else {
                    var SKUArray2 = (0,utils/* getSkus */.ES)(product1.item);
                    if (SKUArray2.length > 0) {
                        var ref63;
                        var data3 = {
                            lizeeSKUs: SKUArray2
                        };
                        getStock1(data3, warehouseId);
                        (prismic === null || prismic === void 0 ? void 0 : (ref63 = prismic.general) === null || ref63 === void 0 ? void 0 : ref63.wishlist_enabled) && checkWishListExistence1([
                            product1.item.id
                        ]);
                    }
                }
            }
        } else didMountProduct.current = true;
    }, [
        product1.item,
        (ref11 = cart.item) === null || ref11 === void 0 ? void 0 : ref11.startLeasingDate,
        (ref12 = cart.item) === null || ref12 === void 0 ? void 0 : ref12.endLeasingDate
    ]);
    // Pack Stock Management
    (0,react.useEffect)(function() {
        if (didMountPacks.current === true) {
            var ref;
            if ((packs === null || packs === void 0 ? void 0 : (ref = packs.items) === null || ref === void 0 ? void 0 : ref.length) > 0 && packs.loading === false && cart.status === 'cart live') {
                var ref64, ref65;
                if (((ref64 = cart.item) === null || ref64 === void 0 ? void 0 : ref64.startLeasingDate) && ((ref65 = cart.item) === null || ref65 === void 0 ? void 0 : ref65.endLeasingDate) && !constants/* isSubscription */.Nn) {
                    var ref66;
                    var data = {};
                    var SKUArray = [];
                    packs === null || packs === void 0 ? void 0 : (ref66 = packs.items) === null || ref66 === void 0 ? void 0 : ref66.map(function(pack) {
                        var SKUs = (0,utils/* getSkus */.ES)(pack.packProducts);
                        var listAssociatedItems = getAssociatedProducts(pack === null || pack === void 0 ? void 0 : pack.productsAssociations);
                        var ProductsSKUs = (0,utils/* getSkus */.ES)(listAssociatedItems);
                        if (SKUArray.length > 0) {
                            if (ProductsSKUs.length > 0) {
                                var _SKUsArray;
                                var SKUsArray = [];
                                (_SKUsArray = SKUsArray).push.apply(_SKUsArray, _toConsumableArray(SKUs).concat(_toConsumableArray(ProductsSKUs)));
                                SKUArray = (0,utils/* arrayUnique */.uW)(SKUArray.concat(SKUsArray));
                            } else {
                                SKUArray = (0,utils/* arrayUnique */.uW)(SKUArray.concat(SKUs));
                            }
                        } else {
                            if (ProductsSKUs.length > 0) {
                                var _SKUsArray1;
                                var SKUsArray1 = [];
                                (_SKUsArray1 = SKUsArray1).push.apply(_SKUsArray1, _toConsumableArray(SKUs).concat(_toConsumableArray(ProductsSKUs)));
                                SKUArray = SKUsArray1;
                            } else {
                                SKUArray = SKUs;
                            }
                        }
                    });
                    if (SKUArray.length > 0) {
                        var ref67, ref68;
                        data = {
                            lizeeSKUs: SKUArray,
                            from: dayjs_min_default()((ref67 = cart.item) === null || ref67 === void 0 ? void 0 : ref67.startLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                            to: dayjs_min_default()((ref68 = cart.item) === null || ref68 === void 0 ? void 0 : ref68.endLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                        };
                        getStock1(data, warehouseId);
                    }
                } else {
                    var ref69;
                    var data4 = {};
                    var SKUArray3 = [];
                    (ref69 = packs.items) === null || ref69 === void 0 ? void 0 : ref69.map(function(pack) {
                        var SKUs = (0,utils/* getSkus */.ES)(pack.packProducts);
                        var listAssociatedItems = getAssociatedProducts(pack === null || pack === void 0 ? void 0 : pack.productsAssociations);
                        var ProductsSKUs = (0,utils/* getSkus */.ES)(listAssociatedItems);
                        if (SKUArray3.length > 0) {
                            if (ProductsSKUs.length > 0) {
                                var _SKUsArray;
                                var SKUsArray = [];
                                (_SKUsArray = SKUsArray).push.apply(_SKUsArray, _toConsumableArray(SKUs).concat(_toConsumableArray(ProductsSKUs)));
                                SKUArray3 = (0,utils/* arrayUnique */.uW)(SKUArray3.concat(SKUsArray));
                            } else {
                                SKUArray3 = (0,utils/* arrayUnique */.uW)(SKUArray3.concat(SKUs));
                            }
                        } else {
                            if (ProductsSKUs.length > 0) {
                                var _SKUsArray2;
                                var SKUsArray2 = [];
                                (_SKUsArray2 = SKUsArray2).push.apply(_SKUsArray2, _toConsumableArray(SKUs).concat(_toConsumableArray(ProductsSKUs)));
                                SKUArray3 = SKUsArray2;
                            } else {
                                SKUArray3 = SKUs;
                            }
                        }
                    });
                    if (SKUArray3.length > 0) {
                        data4 = {
                            lizeeSKUs: SKUArray3
                        };
                        getStock1(data4, warehouseId);
                    }
                }
            }
        } else didMountPacks.current = true;
    }, [
        packs.items,
        (ref13 = cart.item) === null || ref13 === void 0 ? void 0 : ref13.startLeasingDate,
        (ref14 = cart.item) === null || ref14 === void 0 ? void 0 : ref14.endLeasingDate
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.id) {
            // getUserOrders if user exists and has no order saved in state
            if (!(user === null || user === void 0 ? void 0 : user.orders)) {
                getUserOrders1();
                if (false) { var asyncFunc; }
            }
            // getUserBalance if user exists and has no balance saved in state
            if (!(user === null || user === void 0 ? void 0 : user.balance)) {
                getUserBalance1();
            }
        }
    }, [
        user === null || user === void 0 ? void 0 : (ref15 = user.user) === null || ref15 === void 0 ? void 0 : ref15.id
    ]);
    // handle user automatic connection
    (0,react.useEffect)(function() {
        var ref;
        var token = localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
        var hasToken = token != null && token !== 'null';
        if (hasToken && !(user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.id)) {
            var restoreSession = function() {
                var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                    var result;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return getUser1();
                            case 2:
                                result = _ctx.sent;
                                if (result.type === 'GET_USER_FAILURE') {
                                    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
                                    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE);
                                    deleteUser1();
                                }
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function restoreSession() {
                    return _ref.apply(this, arguments);
                };
            }();
            restoreSession();
        } else {
            finishSessionCheck1();
        }
    }, []);
    // get promotions
    (0,react.useEffect)(function() {
        var ref;
        if ((promotions === null || promotions === void 0 ? void 0 : (ref = promotions.items) === null || ref === void 0 ? void 0 : ref.length) === 0 && !promotions.loading && !promotions.fetched) {
            getPromotions1();
        }
    }, [
        promotions === null || promotions === void 0 ? void 0 : promotions.items,
        promotions.loading,
        promotions.fetched
    ]);
    //Futur classic subscription price if connected
    (0,react.useEffect)(function() {
        var ref77, ref70, ref71;
        /*
      Here we watch 3 states : the items in current cart, the promotions
    */ /* Here we have to check if the user exists, that he already have some orders, 
    that we are in classic_subscription, if we have some promotions and if we have products in our customer's cart */ if (false) { var asyncFunction; }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref16 = cart.item) === null || ref16 === void 0 ? void 0 : ref16.items,
        promotions === null || promotions === void 0 ? void 0 : promotions.items,
        user === null || user === void 0 ? void 0 : (ref17 = user.user) === null || ref17 === void 0 ? void 0 : ref17.id,
        user === null || user === void 0 ? void 0 : (ref18 = user.orders) === null || ref18 === void 0 ? void 0 : ref18.length, 
    ]);
    // Function to destroy any cart created before today's date
    (0,react.useEffect)(function() {
        var ref87;
        var createCartPromise;
        if ((cart === null || cart === void 0 ? void 0 : (ref87 = cart.item) === null || ref87 === void 0 ? void 0 : ref87.startLeasingDate) && (parameters === null || parameters === void 0 ? void 0 : parameters.items) && holidaysLoaded) {
            var asyncFunc = function() {
                var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                    var ref, ref81, ref82, ref83, ref84, ref85, ref86, minimumStartingDays, minimumLeasingDays, startDate, endDate;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                minimumStartingDays = typeof (stores === null || stores === void 0 ? void 0 : (ref = stores.selectedStore) === null || ref === void 0 ? void 0 : ref.minimumStartingDays) !== 'undefined' ? stores.selectedStore.minimumStartingDays : typeof (parameters === null || parameters === void 0 ? void 0 : (ref81 = parameters.items) === null || ref81 === void 0 ? void 0 : ref81.minimumStartingDays) !== 'undefined' ? parameters === null || parameters === void 0 ? void 0 : (ref82 = parameters.items) === null || ref82 === void 0 ? void 0 : ref82.minimumStartingDays : 7;
                                minimumLeasingDays = typeof (parameters === null || parameters === void 0 ? void 0 : (ref83 = parameters.items) === null || ref83 === void 0 ? void 0 : ref83.minimumLeasingDays) !== 'undefined' ? parseInt("".concat(parameters === null || parameters === void 0 ? void 0 : (ref84 = parameters.items) === null || ref84 === void 0 ? void 0 : ref84.minimumLeasingDays)) : 2;
                                startDate = (0,businessDays/* getMinimumStartDate */.u)(minimumStartingDays, parameters === null || parameters === void 0 ? void 0 : (ref85 = parameters.items) === null || ref85 === void 0 ? void 0 : ref85.isSaturdayABusinessDay, publicHolidays, !!(prismic === null || prismic === void 0 ? void 0 : (ref86 = prismic.general) === null || ref86 === void 0 ? void 0 : ref86.disable_sunday_on_date_picker));
                                endDate = dayjs_min_default()(startDate).add(minimumLeasingDays - 1, 'day').toDate();
                                if (!(dayjs_min_default()(cart === null || cart === void 0 ? void 0 : cart.item.startLeasingDate, 'DD/MM/YYYY').diff(startDate, 'day') < 0)) {
                                    _ctx.next = 16;
                                    break;
                                }
                                _ctx.next = 8;
                                return deleteCart();
                            case 8:
                                if (constants/* isSubscription */.Nn) {
                                    _ctx.next = 14;
                                    break;
                                }
                                createCartPromise = setTimeout(function() {
                                    return createCart(dayjs_min_default()(startDate), dayjs_min_default()(endDate), warehouseId);
                                }, 700);
                                _ctx.next = 12;
                                return createCart(dayjs_min_default()(startDate), dayjs_min_default()(endDate), warehouseId);
                            case 12:
                                _ctx.next = 16;
                                break;
                            case 14:
                                _ctx.next = 16;
                                return createSubscriptionCart(dayjs_min_default()(startDate), 1, warehouseId);
                            case 16:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function asyncFunc() {
                    return _ref.apply(this, arguments);
                };
            }();
            asyncFunc();
        }
        return function() {
            if (createCartPromise) {
                clearTimeout(createCartPromise);
            }
        };
    }, [
        cart === null || cart === void 0 ? void 0 : (ref19 = cart.item) === null || ref19 === void 0 ? void 0 : ref19.startLeasingDate,
        holidaysLoaded,
        parameters === null || parameters === void 0 ? void 0 : parameters.items,
        prismic === null || prismic === void 0 ? void 0 : (ref20 = prismic.general) === null || ref20 === void 0 ? void 0 : ref20.disable_sunday_on_date_picker,
        publicHolidays,
        stores === null || stores === void 0 ? void 0 : stores.selectedStore, 
    ]);
    // Save chosen date
    (0,react.useEffect)(function() {
        var ref, ref88;
        if ((cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.startLeasingDate) && (cart === null || cart === void 0 ? void 0 : (ref88 = cart.item) === null || ref88 === void 0 ? void 0 : ref88.endLeasingDate)) {
            var ref89, ref90;
            localStorage.setItem("".concat(constants/* SAVED_START_DATE */.zf), cart === null || cart === void 0 ? void 0 : (ref89 = cart.item) === null || ref89 === void 0 ? void 0 : ref89.startLeasingDate);
            localStorage.setItem("".concat(constants/* SAVED_END_DATE */.mG), cart === null || cart === void 0 ? void 0 : (ref90 = cart.item) === null || ref90 === void 0 ? void 0 : ref90.endLeasingDate);
        }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref21 = cart.item) === null || ref21 === void 0 ? void 0 : ref21.startLeasingDate,
        cart === null || cart === void 0 ? void 0 : (ref22 = cart.item) === null || ref22 === void 0 ? void 0 : ref22.endLeasingDate
    ]);
    // Get parameters
    (0,react.useEffect)(function() {
        if (!(parameters === null || parameters === void 0 ? void 0 : parameters.items)) {
            getParameters1();
        }
    }, []);
    // Get available shipping countries
    (0,react.useEffect)(function() {
        if (!(parameters === null || parameters === void 0 ? void 0 : parameters.countries)) {
            getCountries1();
        }
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    }));
};
/* harmony default export */ var components_CartManager = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(CartManager));


/***/ }),

/***/ 97506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UF": function() { return /* binding */ contract_getInProgressContractCSUB; },
  "R0": function() { return /* binding */ contract_getInProgressContractSUB; }
});

// UNUSED EXPORTS: ACTIONS, GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE, GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST, GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS, GET_IN_PROGRESS_CONTRACT_SUB_FAILURE, GET_IN_PROGRESS_CONTRACT_SUB_REQUEST, GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS

// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./redux/services/contract.ts




var getInProgressContractCSUB = function(state) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.contractCSUB */.KU.contractCSUB,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE), true),
        isV2: true,
        uid: "?state=".concat(state)
    });
};
var getInProgressContractSUB = function(state) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.contractSUB */.KU.contractSUB,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE), true),
        isV2: true,
        uid: "?state=".concat(state)
    });
};

;// CONCATENATED MODULE: ./redux/actions/contract.ts

var ACTIONS = {
    GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST: 'GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST',
    GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS: 'GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS',
    GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE: 'GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE',
    GET_IN_PROGRESS_CONTRACT_SUB_REQUEST: 'GET_IN_PROGRESS_CONTRACT_SUB_REQUEST',
    GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS: 'GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS',
    GET_IN_PROGRESS_CONTRACT_SUB_FAILURE: 'GET_IN_PROGRESS_CONTRACT_SUB_FAILURE'
};
var GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST = function() {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST
    };
};
var GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS = function(currentContract) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS,
        currentContract: currentContract
    };
};
var GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE,
        err: err
    };
};
function contract_getInProgressContractCSUB(state) {
    return function(dispatch) {
        dispatch(GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST());
        return getInProgressContractCSUB(state).then(function(response) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE(err));
        });
    };
}
var GET_IN_PROGRESS_CONTRACT_SUB_REQUEST = function() {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_SUB_REQUEST
    };
};
var GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS = function(currentContract) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS,
        currentContract: currentContract
    };
};
var GET_IN_PROGRESS_CONTRACT_SUB_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_SUB_FAILURE,
        err: err
    };
};
function contract_getInProgressContractSUB(state) {
    return function(dispatch) {
        dispatch(GET_IN_PROGRESS_CONTRACT_SUB_REQUEST());
        return getInProgressContractSUB(state).then(function(response) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_SUB_FAILURE(err));
        });
    };
}


/***/ }),

/***/ 18919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fh": function() { return /* binding */ promotions_getPromotions; },
  "rs": function() { return /* binding */ setCurrentPromotion; },
  "mW": function() { return /* binding */ setFuturePrice; }
});

// UNUSED EXPORTS: ACTIONS, GET_PROMOTIONS_FAILURE, GET_PROMOTIONS_REQUEST, GET_PROMOTIONS_SUCCESS, SET_CURRENT_PROMOTION, SET_FUTUR_PRICE

// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/promotionsService.ts


var getPromotions = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.promotions */.KU.promotions
    });
};

;// CONCATENATED MODULE: ./redux/actions/promotions.ts

var ACTIONS = {
    GET_PROMOTIONS_REQUEST: 'GET_PROMOTIONS_REQUEST',
    GET_PROMOTIONS_SUCCESS: 'GET_PROMOTIONS_SUCCESS',
    GET_PROMOTIONS_FAILURE: 'GET_PROMOTIONS_FAILURE',
    SET_FUTUR_PRICE: 'SET_FUTUR_PRICE',
    SET_CURRENT_PROMOTION: 'SET_CURRENT_PROMOTION'
};
var GET_PROMOTIONS_REQUEST = function() {
    return {
        type: ACTIONS.GET_PROMOTIONS_REQUEST
    };
};
var GET_PROMOTIONS_SUCCESS = function(promotions) {
    return {
        type: ACTIONS.GET_PROMOTIONS_SUCCESS,
        promotions: promotions
    };
};
var GET_PROMOTIONS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PROMOTIONS_FAILURE,
        err: err
    };
};
function promotions_getPromotions() {
    return function(dispatch) {
        dispatch(GET_PROMOTIONS_REQUEST());
        return getPromotions().then(function(response) {
            return dispatch(GET_PROMOTIONS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_PROMOTIONS_FAILURE(err));
        });
    };
}
var SET_FUTUR_PRICE = function(price) {
    return {
        type: ACTIONS.SET_FUTUR_PRICE,
        price: price
    };
};
var SET_CURRENT_PROMOTION = function(currentPromotion) {
    return {
        type: ACTIONS.SET_CURRENT_PROMOTION,
        currentPromotion: currentPromotion
    };
};
function setCurrentPromotion(currentPromotion) {
    return function(dispatch) {
        dispatch(SET_CURRENT_PROMOTION(currentPromotion));
    };
}
function setFuturePrice(price) {
    return function(dispatch) {
        dispatch(SET_FUTUR_PRICE(price));
    };
}


/***/ }),

/***/ 67202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isNonBusinessDay; },
/* harmony export */   "u": function() { return /* binding */ getMinimumStartDate; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

var isNonBusinessDay = function(date, isSaturdayABusinessDay, publicHolidays, /** When set from Prismic `disable_sunday_on_date_picker`, Sundays are non-business. */ disableSundayFromCms) {
    var day = date.day();
    var isSunday = day === 0;
    var isSaturday = day === 6;
    var isHoliday = publicHolidays.has(date.format('YYYY-MM-DD'));
    return !!disableSundayFromCms && isSunday || !isSaturdayABusinessDay && isSaturday || isHoliday;
};
var getMinimumStartDate = function(minimumStartingDays, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms) {
    var startDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()();
    var businessDaysCount = 0;
    while(businessDaysCount < minimumStartingDays){
        startDate = startDate.add(1, 'day');
        if (!isNonBusinessDay(startDate, isSaturdayABusinessDay, publicHolidays, disableSundayFromCms)) {
            businessDaysCount += 1;
        }
    }
    return startDate;
};


/***/ })

}]);